import axios from 'axios'
export default {
    wxShowMenu: function (dataUrl, shareMessage) {
        var shareWxLink = dataUrl.split('#')[0] + 'static/html/redirect.html?app3Redirect=' + encodeURIComponent(dataUrl);
        //alert(shareWxLink)
            axios.get('/v1/common/WeChatShareConfig', {
                params: {
                    url: dataUrl.split('#')[0]
                    // url: 'https://gzh.xunjiangzhimei.cn/'
                }
            }).then(function (res) {
                var getMsg = res.data.data;
                // console.log(shareWxLink)
                wx.config({
                    debug: false, //生产环境需要关闭debug模式
                    appId: getMsg.appId, //appId通过微信服务号后台查看
                    timestamp: getMsg.timestamp, //生成签名的时间戳
                    nonceStr: getMsg.nonceStr, //生成签名的随机字符串
                    signature: getMsg.signature, //签名
                    jsApiList: [ //需要调用的JS接口列表
                        'onMenuShareTimeline', //分享给好友
                        'onMenuShareAppMessage', //分享到朋友圈
                    ]
                });
                wx.ready(function () {
                    let data = JSON.parse(shareMessage)
                    //分享到朋友圈
                    wx.onMenuShareTimeline({
                        title: data.title, // 分享标题
                        link: shareWxLink, // 分享链接
                        imgUrl: data.icon // 分享图标
                    });
                    //分享给朋友
                    wx.onMenuShareAppMessage({
                        title: data.title, // 分享标题
                        desc: data.content,
                        link: shareWxLink, // 分享链接
                        imgUrl: data.icon // 分享图标
                    });
                });
            })
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/share.js